<section id="section-design-library" hlmCard>
  <div hlmCardHeader>
    <h2 hlmCardTitle>Meine Designs</h2>
    <p hlmCardDescription>
      Lege so viele Designs an, wie du möchtest, z. B. eines für Weihnachten. Welches davon gedruckt
      wird, wählst du oben aus.
    </p>
  </div>

  <div hlmCardContent class="space-y-4">
    @if (loading()) {
      <div class="grid gap-3 sm:grid-cols-3" aria-busy="true">
        <hlm-skeleton class="h-28 w-full sm:h-64" />
        <hlm-skeleton class="h-28 w-full sm:h-64" />
        <hlm-skeleton class="h-28 w-full sm:h-64" />
      </div>
    } @else if (designs().length === 0) {
      <hlm-empty class="py-8">
        <div hlmEmptyHeader>
          <div hlmEmptyMedia variant="icon"><ng-icon name="lucideFileUp" /></div>
          <p hlmEmptyTitle>Noch kein Design</p>
          <p hlmEmptyDescription>Starte mit einer Vorlage oder lade dein eigenes Layout hoch.</p>
        </div>
        <div hlmEmptyContent>
          <button hlmBtn size="sm" type="button" (click)="create.emit()">
            <ng-icon name="lucidePlus" />
            Neues Design
          </button>
        </div>
      </hlm-empty>
    } @else {
      <div class="flex flex-wrap items-center gap-2">
        @if (showFilters()) {
          <div class="flex flex-wrap gap-2" role="group" aria-label="Designs filtern">
            @for (f of filters; track f.value) {
              <button
                hlmBtn
                size="sm"
                type="button"
                [variant]="filter() === f.value ? 'default' : 'outline'"
                [attr.aria-pressed]="filter() === f.value"
                (click)="filter.set(f.value)">
                {{ f.label }}
              </button>
            }
          </div>
        }
        <button hlmBtn size="sm" type="button" class="ms-auto" (click)="create.emit()">
          <ng-icon name="lucidePlus" />
          Neues Design
        </button>
      </div>

      <div class="grid gap-3 sm:grid-cols-3">
        @for (design of shown(); track design.public_id) {
          <app-design-card
            [design]="design"
            [isActive]="isActive(design)"
            [busy]="busyId() !== null"
            (activate)="activate.emit($event)"
            (copy)="copy.emit($event)"
            (delete)="delete.emit($event)" />
        }
      </div>
    }
  </div>
</section>
